import { useEffect } from 'react';
import { useAxios, isServerError } from 'src/hooks/use-axios';
import { ShipperUserData } from 'src/pages/shipper-admin/details/types';

export function useShipperUserData(id: string | number) {
  const shipperUserData = useAxios(
    (axios, signal) =>
      axios.request<ShipperUserData>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shipperUsers/user/${id}`,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        // returns 404 for:
        // - unknown IDs
        // - deactivated users
        // - outdated time slices (our id is NOT a userRefId and therefor refers to
        //   a time slice and not the user itself)
        if (isServerError(error) && error.response.status === 404) {
          return error;
        } else {
          throw error;
        }
      },
    }
  );

  useEffect(() => {
    shipperUserData.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shipperUserData;
}

export type ShipperUserDataRequest = ReturnType<typeof useShipperUserData>;
